import { render } from "./BulkLink.vue?vue&type=template&id=b83544c6&scoped=true"
import script from "./BulkLink.vue?vue&type=script&lang=js"
export * from "./BulkLink.vue?vue&type=script&lang=js"

import "./BulkLink.vue?vue&type=style&index=0&id=b83544c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b83544c6"]])

export default __exports__